import moment from 'jalali-moment';
import { DateStatus } from '../../modules/market-watch/models/date.model';
import { DistanceToDateDto } from '../../modules/market-watch/models/market-watch-model';

export const checkDateByRangeDates = (
	serverDate: Date,
	startDate: string,
	endDate: string,
	time: string,
	endTime?: string
): DateStatus => {
	if (!time || time === '-') return DateStatus.WithoutTime;
	if (!endDate) endDate = startDate;
	let startHour: number, startMinute: number, endHour: number, endMinute: number;
	if (endTime) {
		startHour = parseInt(time.substring(0, time.indexOf(':')));
		startMinute = parseInt(time.substring(time.indexOf(':') + 1));
		endHour = parseInt(endTime.substring(0, endTime.indexOf(':')));
		endMinute = parseInt(endTime.substring(endTime.lastIndexOf(':') + 1));
	} else {
		startHour = parseInt(time.substring(0, time.indexOf(':')));
		startMinute = parseInt(time.substring(time.indexOf(':') + 1, time.indexOf('-')));
		endHour = parseInt(time.substring(time.indexOf('-') + 1, time.lastIndexOf(':')));
		endMinute = parseInt(time.substring(time.lastIndexOf(':') + 1));
	}

	const startDateTime = moment.from(startDate, 'fa', 'YYYY/M/D').toDate();
	startDateTime.setHours(startHour, startMinute, 0, 0);
	const endDateTime = moment.from(endDate, 'fa', 'YYYY/M/D').toDate();
	endDateTime.setHours(endHour, endMinute, 0, 0);

	if (serverDate.getTime() < startDateTime.getTime()) return DateStatus.Smaller;
	else if (serverDate.getTime() > endDateTime.getTime()) return DateStatus.Bigger;
	else {
		const start = new Date(serverDate);
		start.setHours(startHour, startMinute, 0, 0);
		const end = new Date(serverDate);
		end.setHours(endHour, endMinute, 0, 0);

		if (serverDate < start || serverDate > end) return DateStatus.Smaller;
		else return DateStatus.InRange;
	}
};

export const getDistanceToDate = (
	serverDate: Date,
	jDateStart: string,
	jDateEnd?: string,
	ipoTime?: string,
	ipoEndTime?: string,
	actionName?: string
): DistanceToDateDto => {
	const startDate = moment.from(jDateStart, 'fa', 'YYYY/M/D').toDate();
	const currentDate = new Date();
	startDate.setHours(0, 0, 0, 0);
	currentDate.setHours(0, 0, 0, 0);
	const Start_And_Current_Date_Difference_In_Time = currentDate.getTime() - startDate.getTime();
	// To calculate the no. of days between two dates
	const Start_And_Current_Date_Difference_In_Days = Math.round(
		Start_And_Current_Date_Difference_In_Time / (1000 * 3600 * 24)
	);
	if (!jDateEnd) {
		if (Start_And_Current_Date_Difference_In_Days > 0)
			return {
				state: Math.abs(Start_And_Current_Date_Difference_In_Days).toString() + ' روز پیش'
			};
		if (Start_And_Current_Date_Difference_In_Days === 0) {
			const status = checkDateByRangeDates(serverDate, jDateStart, jDateEnd, ipoTime, ipoEndTime);
			let state = '';
			switch (status) {
				case DateStatus.Bigger:
					state = 'اتمام ' + actionName;
					break;
				case DateStatus.InRange:
					state = 'در حال ' + actionName;
					break;
				case DateStatus.Smaller:
					state = 'امروز';
					break;
				default:
					break;
			}
			return { state };
		}
		return {
			state: Math.abs(Start_And_Current_Date_Difference_In_Days).toString() + ' روز تا ' + actionName
		};
	}
	const endDate = moment.from(jDateEnd, 'fa', 'YYYY/M/D').toDate();
	endDate.setHours(0, 0, 0, 0);
	const End_And_Current_Date_Difference_In_Time = endDate.getTime() - currentDate.getTime();
	const End_And_Current_Date_Difference_In_Days = Math.round(
		End_And_Current_Date_Difference_In_Time / (1000 * 3600 * 24)
	);
	if (Start_And_Current_Date_Difference_In_Days < 0)
		return {
			state: Math.abs(Start_And_Current_Date_Difference_In_Days).toString() + ' روز تا ' + actionName
		};
	if (Start_And_Current_Date_Difference_In_Days >= 0 && End_And_Current_Date_Difference_In_Days >= 0)
		return {
			state: 'در حال ' + actionName,
			detail:
				End_And_Current_Date_Difference_In_Days > 0
					? ' (' + Math.abs(End_And_Current_Date_Difference_In_Days).toString() + ' روز تا اتمام)'
					: ''
		};
	if (End_And_Current_Date_Difference_In_Days < 0)
		return {
			state: Math.abs(End_And_Current_Date_Difference_In_Days).toString() + ' روز پیش'
		};
};
